<form class="container-fluid" [formGroup]="LicenseFormGroup">
  <div class="row">
    <div class="col">
      <label class="fs-28">Edit Trade License</label>
    </div>
  </div>

  <div class="row row-padding">
    <div class="col-3">
      <button class="btn btn-primary" (click)="viewUploadedLicense()">
        View uploaded license
      </button>
    </div>
    <div class="col-3">
      <button class="btn btn-primary" (click)="uploadLicense()">
        Upload license
      </button>
    </div>

    <div class="col-3">
      <button class="btn btn-primary" (click)="goToTradeLookupListing()">
        Trade lookup listing
      </button>
    </div>
  </div>

  <div class="row row-padding">
    <div class="col-3">
      <div class="row">
        <div class="col">
          <label>License Verification</label>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <select class="form-select" formControlName="verificationType">
            @for (
              VerificationType of VerificationTypes;
              track VerificationType
            ) {
              <option [ngValue]="VerificationType.value">
                {{ VerificationType.label }}
              </option>
            }
          </select>
        </div>
      </div>
    </div>
    <div class="col-3">
      <div class="row">
        <div class="col">
          <label requiredAsterisk>Licensor Region</label>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <select class="form-select" formControlName="licensorRegion">
            @for (LicensorRegion of LicensorRegions; track LicensorRegion) {
              <option [ngValue]="LicensorRegion.value">
                {{ LicensorRegion.label }}
              </option>
            }
          </select>
        </div>
      </div>
    </div>
    @if (LicenseFormGroup.value.licensorRegion === 'Municipality') {
      <div class="col-3">
        <div class="row">
          <div class="col">
            <label>Municipality</label>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <input
              type="text"
              class="form-control"
              formControlName="municipalityName"
            />
          </div>
        </div>
      </div>
    }
    <div class="col-3">
      <div class="row">
        <div class="col">
          <label requiredAsterisk>Expiration Date</label>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="input-group">
            <input
              class="form-control"
              type="text"
              placeholder="mm/dd/yyyy"
              formControlName="expirationDate"
              ngbDatepicker
              container="body"
              #expirationDatePicker="ngbDatepicker"
              appNgbDateInputMask
            />
            <div class="input-group-append">
              <button
                class="btn btn-primary btn-outline-secondary bi bi-calendar"
                (click)="expirationDatePicker.toggle()"
                type="button"
              ></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row row-padding">
    <div class="col-3">
      <div class="row">
        <div class="col">
          <label>License Number</label>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <input
            class="form-control"
            type="text"
            formControlName="licenseNumber"
          />
        </div>
      </div>
    </div>
    <div class="col-3">
      <div class="row">
        <div class="col">
          <label requiredAsterisk>License Status</label>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <select class="form-select" formControlName="status">
            @for (Status of Statuses; track Status) {
              <option [ngValue]="Status.value">
                {{ Status.label }}
              </option>
            }
          </select>
        </div>
      </div>
    </div>
    <div class="col-3">
      <div class="row">
        <div class="col">
          <label>License Classification</label>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <input
            type="text"
            class="form-control"
            formControlName="classification"
          />
        </div>
      </div>
    </div>
    <div class="col-3">
      <div class="row">
        <div class="col">
          <label>Licensee Name</label>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <input type="text" class="form-control" formControlName="name" />
        </div>
      </div>
    </div>
  </div>

  <div class="row row-padding">
    <div class="col-3">
      <div class="row">
        <div class="col">
          <label>Trade Listing</label>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <select class="form-select" formControlName="PrimaryTradeId">
            @for (Trade of Trades; track Trade) {
              <option [ngValue]="Trade.id">
                {{ Trade.name }}
              </option>
            }
          </select>
        </div>
      </div>
    </div>
    <div class="col-3">
      <div class="row">
        <div class="col">
          <label requiredAsterisk>State / Province / Territory</label>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <select class="form-select" formControlName="licenseState">
            @for (
              SubNationalDivision of SubNationalDivisions;
              track SubNationalDivision
            ) {
              <option [ngValue]="SubNationalDivision.abbreviation">
                {{ SubNationalDivision.name }}
              </option>
            }
          </select>
        </div>
      </div>
    </div>
  </div>

  <div class="row row-padding">
    <div class="offset-6 col-3">
      <button class="btn btn-secondary" (click)="close()">Cancel</button>
    </div>
    <div class="col-3">
      <button class="btn btn-primary" (click)="save()">Save</button>
    </div>
  </div>
</form>
